import React from 'react';
import styled from 'styled-components';

import { string } from 'prop-types';
import { inputPropTypesObject } from '../../elements/form/decorators';

const StyledLabel = styled('label')(() => ({
  display: 'inline-block',
  position: 'relative',
  paddingLeft: '24px',
  marginBottom: '12px',
  cursor: 'pointer',
  userSelect: 'none'
}));

const HiddenInput = styled('input')(({ theme }) => ({
  height: 0,
  width: 0,
  visibility: 'hidden',
  '&:checked + span': {
    '&:before': {
      background: theme.colors.main
    },
    '&:after': {
      background: theme.colors.white
    }
  }
}));

const StyledMark = styled('span')(() => ({
  '&:before': {
    content: "''",
    position: 'absolute',
    left: 0,
    borderRadius: '50%',
    width: '16px',
    height: '16px',
    background: '#EEE'
  },
  '&:after': {
    content: "''",
    position: 'absolute',
    left: '6px',
    top: '6px',
    borderRadius: '50%',
    width: '4px',
    height: '4px',
    background: '#EEE'
  }
}));

const Radio = React.forwardRef(({ name, label, value, ...input }, ref) => (
  <StyledLabel>
    <HiddenInput type="radio" name={name} value={value} {...input} ref={ref} />
    <StyledMark>{label}</StyledMark>
  </StyledLabel>
));

Radio.propTypes = {
  ...inputPropTypesObject,
  label: string,
  value: string
};

export default Radio;
